// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.0cf35f3ad',
  revision: '0cf35f3ad',
  branch: 'develop',
  date: 'Tue, 19 May 2026 13:31:31 GMT'
};